const user_type = ["", "Admin", "Shop", "Delivery", "Customer"];

export { user_type }



// WEBPACK FOOTER //
// ./src/constants.js